import type { Episode } from '@/types/content';

export const episodesByDrama: Record<string, Episode[]> = {
  'long-night': [
    {
      episodeId: '1',
      number: 1,
      title: '雨夜旧案',
      content:
        '凌晨三点，城西废弃仓库发现一具无名男尸。顾南川带队赶到现场时，却在死者口袋里发现了一枚与自己童年记忆完全吻合的旧徽章。十二年前那个雨夜的片段再次涌上脑海，被他强行压了下去。同一时刻，法医沈知意从死者指甲缝中提取到一种罕见的工业涂料，这条线索，将整个案件引向一座早已停产的化工厂。',
    },
    {
      episodeId: '2',
      number: 2,
      title: '沉默的涂料',
      content:
        '顾南川与沈知意驱车前往废弃化工厂调查，却在厂区遇上了同样来"散步"的地产集团继承人韩景行。韩景行谈吐温和，主动提供了厂区二十年前的员工名册，态度太过配合，反而让顾南川心生警惕。夜里，名册中一位关键证人被发现死于家中，现场同样干净得没有一丝痕迹。',
    },
    {
      episodeId: '3',
      number: 3,
      title: '记者的笔记',
      content:
        '调查记者叶闻笛找到了顾南川，递上一本被水浸过的采访笔记。原来她一直在追查同一桩旧案，只是每一篇稿件都被莫名压下。两人决定交换情报，虽然彼此都留着后手。笔记本最后一页上，写着一个被反复圈起的名字——那是顾南川再熟悉不过的姓。',
    },
    {
      episodeId: '4',
      number: 4,
      title: '十二年前的雨',
      content:
        '在沈知意的坚持下，顾南川接受了心理回溯测试。测试中，他终于想起了那个雨夜真正发生的事：他不是幸存者，而是唯一的目击者。这一认知让案件的性质彻底改变。与此同时，韩景行向警方递交了一份匿名举报材料，指向市局内部。',
    },
    {
      episodeId: '5',
      number: 5,
      title: '内应的影子',
      content:
        '举报材料牵出的线索指向一名已退役的老刑警。顾南川在对方家中发现了大量与案件相关的剪报，每一张都被仔细标注。老人承认自己当年被迫结案，却拒绝透露是谁下的命令，只留下一句话："查下去，你会失去更多。"',
    },
    {
      episodeId: '6',
      number: 6,
      title: '长夜将明',
      content:
        '随着关键证据被补齐，韩景行的真实立场逐渐浮出水面——他所做的一切，都是为了逼出幕后那只手。顾南川在旧厂房顶楼与真凶对峙，雨终于停了。天亮之前，他做出了一个谁也想不到的决定，也为后续更大的真相留下了伏笔。',
    },
  ],
  'wind-changan': [
    {
      episodeId: '1',
      number: 1,
      title: '密诏入城',
      content:
        '边关告急，少年将军萧承稷在战报中发现朝廷供应的军械竟以次充好。临行前，老将军交给他一纸密诏，命他入长安彻查通敌内鬼。城门在夕阳下缓缓开启，萧承稷握紧了腰间的剑，也握住了自己未知的命运。',
    },
    {
      episodeId: '2',
      number: 2,
      title: '朝堂风起',
      content:
        '初次上朝，萧承稷便因军饷一事与太常寺卿针锋相对。散朝后，苏令仪拦住他，点破了他话里三处破绽，并提醒他：朝堂之上，最忌讳的就是把话说得太明白。两人就此达成一个不成文的默契。',
    },
    {
      episodeId: '3',
      number: 3,
      title: '暗卫姜知微',
      content:
        '萧承稷在驿馆遭遇刺杀，刺客身手诡谲。混战中，一名黑衣人替他挡下致命一刀，随后消失无踪。次日，他却在裴无咎的棋局旁，再次见到了那双眼睛。裴无咎笑而不语，只说"棋到中盘，才见真章"。',
    },
    {
      episodeId: '4',
      number: 4,
      title: '军械账本',
      content:
        '顺着军械批号，萧承稷查到了长安最大的兵器商号，却发现商号背后是太子的门客。他连夜将证据誊抄三份，分别送往三个不同的去处。苏令仪在暗中替他挡下了一次搜查，两人的信任更进一层。',
    },
    {
      episodeId: '5',
      number: 5,
      title: '故人旧约',
      content:
        '萧承稷得知通敌之人竟是自己父亲的旧部，一时难以接受。裴无咎带他登上城楼，讲起了当年那场被史书轻描淡写的兵败。夜色之下，裴无咎终于说出自己入京的真正目的，远不止辅佐一个将军那么简单。',
    },
    {
      episodeId: '6',
      number: 6,
      title: '风起长安',
      content:
        '天亮之前，所有线索汇聚于朱雀大街。萧承稷当众揭穿内鬼，朝堂震动。然而真正的幕后之人在最后一刻抽身离去，只留下半句未说完的话。这一集以一场雪中的长镜头收尾，为后半段的终局埋下重重悬念。',
    },
  ],
  'star-era': [
    {
      episodeId: '1',
      number: 1,
      title: '回声号启航',
      content:
        '"回声号"自地球轨道启程，目标是十二光年外的一颗类地行星。船长陆时衍在启航前删除了私人终端里的最后一段信息。飞船进入休眠航段后第三十天，首席科学家温以宁在监测屏上捕捉到一段不属于任何已知设备的信号——那正是"回声号"自己的呼号。',
    },
    {
      episodeId: '2',
      number: 2,
      title: '来自未来的呼号',
      content:
        '信号中携带的信息经过解码，竟是一段求救坐标，指向人类尚未抵达的深空。船员们就是否改变航线产生激烈分歧。机械师程屿在检修中发现，飞船的曲速引擎记录里，存在一段无人知晓的额外航行日志。',
    },
    {
      episodeId: '3',
      number: 3,
      title: '领航员的秘密',
      content:
        '领航员许清和在压力下终于承认，她的航行数据被篡改过。陆时衍在船桥单独约谈她，得到的答案是：早在出发之前，就有人知道他们会收到这段信号。这一发现，让整场远航变成了一个被安排好的剧本。',
    },
    {
      episodeId: '4',
      number: 4,
      title: '休眠舱异常',
      content:
        '一名船员的休眠舱在无人操作的情况下自动唤醒，而他声称自己在"梦里"见到了本该留在地球的亲人。温以宁将这一现象与求救信号关联，提出一个大胆假设：信号并非来自我们的未来，而是来自另一个尚未发生的选择。',
    },
    {
      episodeId: '5',
      number: 5,
      title: '岔路口',
      content:
        '飞船驶入一片未知星云，通讯彻底中断。程屿用尽办法修复天线，代价是牺牲部分推进能源。陆时衍必须在继续前进与返航之间做出决定，而这个决定，将直接验证温以宁的假设是否正确。',
    },
    {
      episodeId: '6',
      number: 6,
      title: '第四面墙',
      content:
        '当飞船穿过星云，舷窗外出现了另一艘一模一样、却明显更老旧的"回声号"。两船通过灯光信号完成了第一次交流，对方传递的唯一一条信息是："不要相信你们的第一份航行日志。"',
    },
  ],
  'mist-manhunt': [
    {
      episodeId: '1',
      number: 1,
      title: '雾起',
      content:
        '小镇连续第三起失踪案发生，警方束手无策。退休法医裴云天本在钓鱼，却因为新闻里一个熟悉的细节放下了鱼竿。他回到旧宅，从抽屉最底层取出一枚保存了二十年的证物袋——里面装着一枚与现场一模一样的纽扣。',
    },
    {
      episodeId: '2',
      number: 2,
      title: '师徒初见',
      content:
        '年轻刑警谢鹤鸣被派去"请"裴云天出山，起初对这位老法医并不服气。两人在案发现场第一次正面交锋：裴云天仅凭地面一处被踩踏的野草，就推断出嫌疑人离开的方向，谢鹤鸣当场愣住。',
    },
    {
      episodeId: '3',
      number: 3,
      title: '二十年前的卷宗',
      content:
        '裴云天申请调阅旧卷宗被拒，只得另寻他路。他找到当年负责结案的老同事，对方如今卧病在床，只反复念叨一句"那年的雾太大了"。同一时刻，镇上医生秦书宁主动找到警方，提供了一份被忽略的旧病历。',
    },
    {
      episodeId: '4',
      number: 4,
      title: '旅馆里的沉默',
      content:
        '谢鹤鸣在旅馆老板周砚那里碰了钉子，却在离开时注意到墙上挂钟的时间停在特定的一刻。裴云天得知后断定，这是周砚故意留下的暗示。两人深夜重返旅馆，在阁楼里发现了第三名失踪者留下的物品。',
    },
    {
      episodeId: '5',
      number: 5,
      title: '纽扣的主人',
      content:
        '通过物证比对，纽扣的来源被锁定到一家早已倒闭的服装厂。裴云天回忆起二十年前那起案子的细节，第一次在徒弟面前流露出动摇。谢鹤鸣第一次意识到，师父调查的不只是一桩案子，而是自己的过去。',
    },
    {
      episodeId: '6',
      number: 6,
      title: '雾散之前',
      content:
        '所有线索指向小镇唯一没有离开过的人。真相揭晓前的最后一晚，裴云天独自前往湖边，与凶手进行了一场没有记录的对话。他带回来的，是一份足以推翻旧案的完整证据链。',
    },
  ],
  'city-drifter': [
    {
      episodeId: '1',
      number: 1,
      title: '第七次搬家',
      content:
        '江砚白拖着两个行李箱，第七次搬进这座城市的老小区。合租的室友一个是自由插画师夏知遥，一个是白天送外卖、晚上玩乐队的地下主唱孟星野。三个人在堆满纸箱的客厅里吃了第一顿饭，谁都没提自己刚被现实按在地上摩擦的处境。',
    },
    {
      episodeId: '2',
      number: 2,
      title: '被优化的名单',
      content:
        '江砚白所在的项目被突然叫停，他被列入了"优化名单"。回家路上，他在便利店门口站了很久，最终没有打电话。夏知遥察觉到了异样，默默把自己的插画稿费分成两半，塞进了冰箱的便签板里。',
    },
    {
      episodeId: '3',
      number: 3,
      title: '深夜的演出',
      content:
        '孟星野的乐队好不容易争取到一场演出，现场却只来了七个人。唱到最后一首时，江砚白和夏知遥举着手机闪光灯站到了台下。三个人在散场后的天桥上放声大笑，那一刻，窘迫好像也没那么可怕。',
    },
    {
      episodeId: '4',
      number: 4,
      title: '一个机会',
      content:
        '创业公司创始人钟以棠在一次行业活动上注意到江砚白，向他递出了一份邀约。机会来得突然，也带着风险。江砚白第一次认真思考：自己想要的，到底是一份稳定的工作，还是一次真正属于自己的尝试。',
    },
    {
      episodeId: '5',
      number: 5,
      title: '房租到期',
      content:
        '房东通知涨租，三个人凑在一起算账，怎么算都差一截。夏知遥提出退租回老家，被另外两人一致否决。那一晚他们列了一张"半年计划"清单，把每一条不切实际的梦想都郑重地写了上去。',
    },
    {
      episodeId: '6',
      number: 6,
      title: '体面',
      content:
        '江砚白决定加入钟以棠的团队。签下名字的那一刻，他忽然明白，所谓体面的生活，不是别人眼里的样子，而是每天醒来都愿意继续努力的理由。这一集以三个人在天台上吃泡面收尾。',
    },
  ],
  'mountain-mystery': [
    {
      episodeId: '1',
      number: 1,
      title: '出发',
      content:
        '考古队在段祺临的带领下进入西南无人区，目标是传说中一夜消失的古国遗址。白清晏带来的古文字拓片，与当地向导岑仲口中的民间传说意外吻合。队伍出发的第一天，摄影师苏黎就注意到，有人偷偷在她的器材箱里塞了一张手绘地图。',
    },
    {
      episodeId: '2',
      number: 2,
      title: '地图之外',
      content:
        '队伍按照地图行进，却在第三天到达一处地图上不存在的高原湖泊。岑仲解释说是近年地质变化所致，白清晏却发现湖边有大量人为活动的痕迹。夜里，营地外传来不明的脚步声。',
    },
    {
      episodeId: '3',
      number: 3,
      title: '石壁上的字',
      content:
        '苏黎在一处石壁上拍到了与古国文字极为相似的刻痕。白清晏日夜破译，终于读出其中一句："勿信带路之人。"这句话让整个队伍的气氛骤然紧张，段祺临第一次对岑仲产生了怀疑。',
    },
    {
      episodeId: '4',
      number: 4,
      title: '断裂的绳桥',
      content:
        '翻越峡谷时，唯一的绳桥突然断裂，一名队员险些坠崖。事后检查发现，绳索的磨损并不自然。段祺临在众人面前没有点名，却在私下向白清晏坦诚：这趟旅程，从一开始就有人不希望他们找到真相。',
    },
    {
      episodeId: '5',
      number: 5,
      title: '遗址之门',
      content:
        '队伍终于找到了古国遗址的入口。门楣上的浮雕讲述着一个关于迁徙与背叛的故事，与段祺临寻找的答案惊人地相似。也在这一刻，岑仲说出了他隐瞒已久的真实身份。',
    },
    {
      episodeId: '6',
      number: 6,
      title: '山海之间',
      content:
        '遗址内部的发现颠覆了所有人的认知。段祺临必须在公开真相与保护遗址之间做出选择。当队伍带着有限的资料撤出无人区时，镜头定格在苏黎相机里那张谁也没看清的照片上。',
    },
  ],
  'spring-confession': [
    {
      episodeId: '1',
      number: 1,
      title: '新来的总监',
      content:
        '林晚意入职第一天，就在会议室里撞见了八年前的暗恋对象。如今的他西装革履，是她的直属总监。宋亦寒只是平静地念出她的名字，仿佛从未认识过她。可散会后，同事傅司南打趣地说，宋总昨晚特意把入职名单看了三遍。',
    },
    {
      episodeId: '2',
      number: 2,
      title: '加班到深夜',
      content:
        '项目上线在即，整个组加班到凌晨。宋亦寒默默给每人点了夜宵，唯独在林晚意那份里多放了一罐她高中时最爱喝的橘子汽水。她捧着那罐汽水，忽然不知道该说什么。',
    },
    {
      episodeId: '3',
      number: 3,
      title: '出差',
      content:
        '两人被安排去外地出差，航班延误，酒店只剩一间房。尴尬一夜之后，宋亦寒把沙发让给她，自己在窗边坐了整晚。第二天清晨，他递给她一份改好的方案，页脚写着一行很小的字：这次，别再假装不认识我。',
    },
    {
      episodeId: '4',
      number: 4,
      title: '竞争对手',
      content:
        '能力出众的黎昭加入团队，与林晚意展开了正面竞争。她并不使坏，只是坦率地表达欣赏宋亦寒。林晚意第一次意识到，有些心动如果不说出口，就会一次次被别人抢先。',
    },
    {
      episodeId: '5',
      number: 5,
      title: '八年前的信',
      content:
        '整理旧物时，林晚意发现了一封从未寄出的信，落款正是八年前的宋亦寒。原来当年那场错过，是双向的沉默。她把信拍了照，却迟迟没有发出去。',
    },
    {
      episodeId: '6',
      number: 6,
      title: '春日告白',
      content:
        '樱花再次开满校园外的那条路。宋亦寒约林晚意回到高中，在当年她等他的那棵树下，说出了迟到八年的话。这一集没有多余的台词，只有风吹过花瓣的声音和两个终于并肩的人。',
    },
  ],
  'brocade-moon': [
    {
      episodeId: '1',
      number: 1,
      title: '赐婚',
      content:
        '一道赐婚圣旨，把将门之女沈月昭与质子皇子谢景彻绑在了一起。两人在皇城初见，一个冷脸，一个假笑。沈月昭当众放话："这婚事，我认；这人，我不认。"谢景彻只是替她扶正了被风吹歪的披风。',
    },
    {
      episodeId: '2',
      number: 2,
      title: '同床异梦',
      content:
        '新婚之夜，两人分坐烛火两侧，各自盘算。谢景彻主动交出一份朝中暗桩名单，以此为信，换来沈月昭手中边关的旧部资源。这一场交易，成了他们并肩的起点。',
    },
    {
      episodeId: '3',
      number: 3,
      title: '太子之局',
      content:
        '太子萧沐辰设宴试探，席间处处是陷阱。沈月昭仗着将门身份高谈阔论，替谢景彻挡下三次暗问。散宴后，谢景彻第一次认真看她，说出了全剧第一句真心话："今日，多谢。"',
    },
    {
      episodeId: '4',
      number: 4,
      title: '温如絮的心事',
      content:
        '沈月昭的挚友温如絮被卷入一场流言，险些毁了清白。谢景彻暗中出手化解，却因此暴露了自己的一条暗线。沈月昭终于明白，这个看似闲散的皇子，考虑的远比她想象的更远。',
    },
    {
      episodeId: '5',
      number: 5,
      title: '围猎',
      content:
        '秋猎场上暗藏杀机，谢景彻为护太子身中冷箭。沈月昭策马挡在他身前，一箭断了刺客的退路。血泊之中，两人第一次真正意义上的心意相通。',
    },
    {
      episodeId: '6',
      number: 6,
      title: '月下之誓',
      content:
        '养伤期间，谢景彻与沈月昭在宫墙下的月影里立誓：无论谁坐上那把椅子，都要护住这满城烟火。当夜，一封密信被送入太子府，预示着更大的风暴即将来临。',
    },
  ],
  'neon-fox': [
    {
      episodeId: '1',
      number: 1,
      title: '错误的身份',
      content:
        '程序员许砚深为了还贷，接了一单来路不明的"身份认证"外包。交付当天，雇主消失，他的个人信息却被挂进了一个加密论坛。更糟的是，一名陌生女子敲开了他家的门，自称是唯一能救他的人。',
    },
    {
      episodeId: '2',
      number: 2,
      title: '暗网之门',
      content:
        '纪云舒带许砚深潜入信息黑市，用一台报废终端换取了第一手线索。她手法娴熟，却在关键时刻故意漏掉了一个节点，让追踪他们的安全公司分析师柯屿找到了痕迹。许砚深开始怀疑，她到底站在哪一边。',
    },
    {
      episodeId: '3',
      number: 3,
      title: '算法画像',
      content:
        '柯屿登门"拜访"，话里话外都在暗示许砚深的身份被人冒用了很久。三人之间的博弈在一间咖啡馆里展开。离开前，柯屿留下一句："你以为你是受害者，但数据不会说谎。"',
    },
    {
      episodeId: '4',
      number: 4,
      title: '被删掉的那一天',
      content:
        '许砚深发现自己的档案里，有一整天的记录被彻底抹去。记者安之提供了关键线索：类似被删除的档案，近年来有上百份。他们第一次意识到，这不是一桩针对个人的案子，而是一套运行多年的系统。',
    },
    {
      episodeId: '5',
      number: 5,
      title: '狐影现身',
      content:
        '纪云舒终于坦白：她曾是这套系统的开发者之一。她带着许砚深回到自己"死亡"那天的现场，用一段残留日志证明了系统的存在。霓虹灯下，两人第一次达成了真正的同盟。',
    },
    {
      episodeId: '6',
      number: 6,
      title: '真实身份',
      content:
        '在所有证据即将公开的最后一刻，系统的掌权者主动现身，提出的条件却出乎所有人意料。许砚深必须决定：是公开真相，还是用这个秘密换回自己被抹去的人生。',
    },
  ],
  'warm-fireworks': [
    {
      episodeId: '1',
      number: 1,
      title: '老街的清晨',
      content:
        '天还没亮，吴长庚已经开始熬当天第一锅汤。女儿郑好拖着行李从大城市回来，进门第一句就是"我只是回来住几天"。父亲没抬头，只往她碗里多放了一个卤蛋。',
    },
    {
      episodeId: '2',
      number: 2,
      title: '一场争吵',
      content:
        '郑好提出想盘下街角空铺做设计工作室，被父亲一口否决。两人在面馆当着客人的面吵了起来，最后以郑好摔门收场。孙女何以安躲在柜台后，默默把爷爷掉在地上的擀面杖捡了起来。',
    },
    {
      episodeId: '3',
      number: 3,
      title: '妈妈的味道',
      content:
        '母亲周淑仪用一碗最简单的手擀面，把父女俩重新按回了同一张桌子。饭桌上谁也没道歉，可汤都被喝完了。这一集几乎没有大起大落，却让无数观众看红了眼眶。',
    },
    {
      episodeId: '4',
      number: 4,
      title: '老顾客的秘密',
      content:
        '一位常年坐在角落的老顾客突然不再来了。吴长庚打听到他住进了医院，执意要把汤送到病房。这个小小的举动，让郑好第一次看清，父亲固执的背后，是几十年如一日的分量。',
    },
    {
      episodeId: '5',
      number: 5,
      title: '重新开张',
      content:
        '郑好放弃了大城市的机会，留下来帮父亲改造面馆。新旧理念碰撞不断，但招牌菜始终没变。开业那天，老街上的街坊几乎都来了。',
    },
    {
      episodeId: '6',
      number: 6,
      title: '烟火人间',
      content:
        '除夕夜，一家三代围坐在重新亮起的面馆里。吴长庚第一次说出了那句藏了几十年的话。窗外烟花升起，映亮每一张脸。故事在热闹的锅气里，落下一个温柔的句点。',
    },
  ],
  'ten-years': [
    {
      episodeId: '1',
      number: 1,
      title: '十年之约',
      content:
        '毕业十年，柏川在群里发起了聚会。四个人里有三个都说"看情况"。最后到场的，只有唐叙一个人。他坐在当年常去的那家小饭馆里，点了一桌菜，等了一个通宵。',
    },
    {
      episodeId: '2',
      number: 2,
      title: '旧照片',
      content:
        '夏之岸翻出大学时的胶卷，冲洗后照片里的四个人笑得毫无顾虑。她把照片发进群里，沉寂多年的对话框第一次热闹起来。阮清野看着照片，很久没有回消息。',
    },
    {
      episodeId: '3',
      number: 3,
      title: '各自的十年',
      content:
        '四个人终于凑齐。有人已经结婚生子，有人刚经历失败，有人还在原地打转。酒过三巡，当年那个"再也不联系"的狠话被提起，谁都没有接话。',
    },
    {
      episodeId: '4',
      number: 4,
      title: '道歉',
      content:
        '阮清野在散场后单独找到了唐叙。十年前的那场误会，原来是一场谁都不肯先低头的倔强。两人在天台上抽完一整包烟，把该说的话终于说完。',
    },
    {
      episodeId: '5',
      number: 5,
      title: '一首歌',
      content:
        '柏川把当年没写完的那首歌补完了，在聚会的最后一晚唱了出来。唱到副歌时，所有人都跟着和。夏之岸举着相机，记录下了这一刻。',
    },
    {
      episodeId: '6',
      number: 6,
      title: '下一个十年',
      content:
        '分别那天，四人约定十年后再聚，这一次不用"看情况"。故事结束在他们背影拉长的小路上，也结束在每个人心里那句没有说出口的"谢谢你还在"。',
    },
  ],
  'dragon-city': [
    {
      episodeId: '1',
      number: 1,
      title: '龙城1984',
      content:
        '厂区的大喇叭里播放着广播，程建国在车间里改进了第一台设备。消息传到厂部，有人拍手，也有人皱眉。林秀兰在纺织车间隔着窗户看见他被叫去开会，心里莫名有些不安。',
    },
    {
      episodeId: '2',
      number: 2,
      title: '下岗通知',
      content:
        '一纸通知贴在了厂门口，许多熟悉的名字出现在名单上。赵卫东守着车间不肯走，程建国却做了一个让所有人意外的决定——他第一个递交了辞职申请。',
    },
    {
      episodeId: '3',
      number: 3,
      title: '第一桶金',
      content:
        '程建国带着几个人南下进货，吃了无数闭门羹。第一次赚到钱的晚上，几个大男人挤在小旅馆里，把钞票铺了满床。他没有告诉任何人，自己偷偷给林秀兰留了一份。',
    },
    {
      episodeId: '4',
      number: 4,
      title: '大学生回来了',
      content:
        '何小满大学毕业回到龙城，带回了外面世界的新鲜想法。她想推动厂里做技术改革，却被老规矩处处掣肘。程建国第一个站出来支持她，也第一次与赵卫东产生了分歧。',
    },
    {
      episodeId: '5',
      number: 5,
      title: '时代的岔路',
      content:
        '改革的浪潮席卷而来，有人抓住机会，有人被甩在身后。林秀兰在爱情与现实之间做出了选择，那个决定让三个人的人生从此走上了不同的轨道。',
    },
    {
      episodeId: '6',
      number: 6,
      title: '往事如烟',
      content:
        '多年以后，龙城早已不是当年的模样。头发花白的程建国回到老厂门口，看见赵卫东正守着那台他改造过的旧设备。两人相视一笑，什么也没说，往事却都在眼里。',
    },
  ],
};